import { css } from "styled-components";

const SwiperCss = css`
  & .swiper-pagination-bullets {
    & .swiper-pagination-bullet {
      background: white;
      opacity: 0.8;
      box-shadow: 0 0 2px black, 0 0 2px black, 0 0 3px black;

      &.swiper-pagination-bullet-active {
        opacity: 1;
        box-shadow: 0 0 2px black, 0 0 2px black, 0 0 3px black, 0 0 3px black, 0 0 4px black, 0 0 4px black;
      }
    }
  }

  & .swiper-button-prev {
    color: white;
    left: 0;

    &:after {
      text-shadow: 0 0 2px black, 0 0 2px black, 0 0 3px black, 0 0 3px black, 0 0 4px black, 0 0 4px black;
      @media screen and (max-width: 960px) {
        font-size: 20px;
      }
      @media screen and (min-width: 961px) {
        font-size: 30px;
      }
    }
  }

  & .swiper-button-next {
    color: white;
    right: 0;

    &:after {
      text-shadow: 0 0 2px black, 0 0 2px black, 0 0 3px black, 0 0 3px black, 0 0 4px black, 0 0 4px black;
      @media screen and (max-width: 960px) {
        font-size: 20px;
      }
      @media screen and (min-width: 961px) {
        font-size: 30px;
      }
    }
  }
`;
export default SwiperCss;
